import { ISocialPlatform } from '@/interfaces/socials'
import React from 'react'

// styles
import {
  GRAY_SOCIAL_ICONS,
  IMAGE_PATHS_V2,
  SOCIAL_ICONS,
} from '@/shared/consts/imagesPaths'
import { getSocialUserUrl } from '@/shared/utils/getSocialUserUrl'
import { cssClass } from '@/shared/utils/styles'
import Image from 'next/image'
import Link from 'next/link'
import { skeleton } from '../skeleton/styles/index.css'
import { socialIconLinkContainerGray } from './styles/styles.css'

type BaseProps = {
  social: ISocialPlatform
  filterGray?: boolean
  size?: number
  alt?: string
  onClick?: (platform: ISocialPlatform) => void
  isLoading?: boolean
}

interface WithSocialAndUsernameProps extends BaseProps {
  username: string
}

interface WithCustomUrlProps extends BaseProps {
  customUrl: string
}

type Props = WithSocialAndUsernameProps | WithCustomUrlProps

export const SocialIconLink: React.FC<Props> = (props) => {
  const {
    social,
    filterGray = false,
    size = 32,
    onClick,
    alt = 'social_icon',
    isLoading = false,
  } = props

  const url =
    'customUrl' in props
      ? props.customUrl
      : getSocialUserUrl(social, props.username)

  const [loaded, setLoaded] = React.useState(false)

  const imageName = filterGray
    ? GRAY_SOCIAL_ICONS[social]
    : SOCIAL_ICONS[social]
  const imagePath = `${IMAGE_PATHS_V2.icons.socials}${imageName}`

  return (
    <div
      onClick={() => onClick && onClick(social)}
      style={{ width: size, aspectRatio: '1/1', borderRadius: '50%' }}
      className={cssClass([
        'flex justify-center items-center relative',
        filterGray && socialIconLinkContainerGray,
        skeleton,
      ])}
    >
      {!isLoading &&
        (onClick ? (
          <Image
            src={imagePath}
            alt={`${alt}_${social}`}
            sizes={`${size + 2}px`}
            fill
            onLoad={() => setLoaded(true)}
            className={loaded ? 'opacity-100 cursor-pointer' : 'opacity-0'}
          />
        ) : (
          <Link href={url} target="_blank" className="absolute full-w full-h">
            <Image
              src={imagePath}
              alt={`${alt}_${social}`}
              sizes={`${size + 8}px`}
              fill
              onLoad={() => setLoaded(true)}
              className={loaded ? 'opacity-100' : 'opacity-0'}
            />
          </Link>
        ))}
    </div>
  )
}
